/* eslint-disable max-len */
import 'rxjs/add/operator/partition';
import { partition } from 'rxjs/operators/partition';

const createPartitions = () => (stream) => {
  const [keptInitialAddress, notKeptInitialAddress] = stream.pipe(
    partition(
      ({
        hasChangedShippingSelection,
        hasChangedBillingSelection,
        isSameShipping,
        billingAddress,
        isDownloadOnly,
        isAddAddressShown,
        isFormValid,
        isTotallyNewUser,
      }) =>
        (!isAddAddressShown &&
          !isTotallyNewUser &&
          isSameShipping &&
          !hasChangedShippingSelection) ||
        (isFormValid &&
          isDownloadOnly &&
          !hasChangedBillingSelection &&
          !hasChangedShippingSelection &&
          !isAddAddressShown &&
          !isTotallyNewUser &&
          billingAddress)
    )
  );

  const [
    changedBillingAddressSelection,
    notChangedBillingAddressSelection,
  ] = notKeptInitialAddress.pipe(
    partition(
      ({ hasChangedBillingSelection, isAddAddressShown, isDownloadOnly }) =>
        hasChangedBillingSelection && !isAddAddressShown && isDownloadOnly
    )
  );

  const [
    incompleteForm,
    notIncompleteForm,
  ] = notChangedBillingAddressSelection.pipe(
    partition(
      ({ isTotallyNewUser, isSameShipping, isFormValid, isAddAddressShown }) =>
        (!isFormValid && !isSameShipping) ||
        (!isFormValid && isAddAddressShown) ||
        (!isFormValid && isTotallyNewUser)
    )
  );

  const [
    addBothNewFullAddresses,
    notAddBothNewFullAddresses,
  ] = notIncompleteForm.pipe(
    partition(
      ({
        isShippingGroupValid,
        isBillingGroupValid,
        isDownloadOnly,
        isSameShipping,
        isAddAddressShown,
        isTotallyNewUser,
      }) =>
        !isDownloadOnly &&
        (isAddAddressShown || isTotallyNewUser) &&
        !isSameShipping &&
        isShippingGroupValid &&
        isBillingGroupValid
    )
  );

  const [
    addShippingAndSyncBilling,
    notAddNewShippingAndSyncBilling,
  ] = notAddBothNewFullAddresses.pipe(
    partition(
      ({
        hasChangedBillingSelection,
        hasChangedShippingSelection,
        isShippingGroupValid,
        isSameShipping,
        isDownloadOnly,
      }) =>
        !isDownloadOnly &&
        !hasChangedBillingSelection &&
        !hasChangedShippingSelection &&
        isShippingGroupValid &&
        isSameShipping
    )
  );

  const [
    changeFullDefaultBillingAddress,
    notChangeFullDefaultBillingAddress,
  ] = notAddNewShippingAndSyncBilling.pipe(
    partition(
      ({
        isBillingGroupValid,
        isSameShipping,
        isDownloadOnly,
        isTotallyNewUser,
        isAddAddressShown,
      }) =>
        isBillingGroupValid &&
        (!isAddAddressShown || isDownloadOnly || isTotallyNewUser) &&
        (!isSameShipping || isDownloadOnly)
    )
  );

  const [
    changeShippingAddress,
    notChangeShippingAddress,
  ] = notAddNewShippingAndSyncBilling.pipe(
    partition(
      ({ isAddAddressShown, hasChangedShippingSelection }) =>
        !isAddAddressShown && hasChangedShippingSelection
    )
  );

  const [
    syncBillingWithSelectedShipping,
    notSyncBillingWithSelectedShipping,
  ] = notChangeFullDefaultBillingAddress.pipe(
    partition(
      ({
        hasChangedShippingSelection,
        isSameShipping,
        isAddAddressShown,
        isShippingGroupValid,
      }) =>
        hasChangedShippingSelection &&
        isSameShipping &&
        isShippingGroupValid &&
        !isAddAddressShown
    )
  );

  const [
    addShippingAddress,
    otherJunk,
  ] = notSyncBillingWithSelectedShipping.pipe(
    partition(
      ({ isAddAddressShown, isShippingGroupValid, isDownloadOnly }) =>
        isAddAddressShown && isShippingGroupValid && !isDownloadOnly
    )
  );

  return {
    keptInitialAddress,
    notKeptInitialAddress,
    changedBillingAddressSelection,
    notChangedBillingAddressSelection,
    incompleteForm,
    notIncompleteForm,
    addBothNewFullAddresses,
    notAddBothNewFullAddresses,
    addShippingAndSyncBilling,
    changeShippingAddress,
    notChangeShippingAddress,
    syncBillingWithSelectedShipping,
    notSyncBillingWithSelectedShipping,
    changeFullDefaultBillingAddress,
    notChangeFullDefaultBillingAddress,
    addShippingAddress,
    otherJunk,
  };
};

export default createPartitions;
